import { z } from "zod";

export const ScheduleActionTypeList = ["start", "pause", "end"] as const;
export type ScheduleAction = (typeof ScheduleActionTypeList)[number];

export const ScheduleDtoSchema = z.object({
  id: z.string().uuid(),
  experienceId: z.string().uuid(),
  action: z.enum(ScheduleActionTypeList),
  executionTime: z.number(),
});

export type ScheduleDto = z.infer<typeof ScheduleDtoSchema>;
